import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { none, SupportScreen } from './supportScreen';

interface SupportState {
  viewModel: SupportScreen.ViewModel;
}

const initialState: SupportState = {
  viewModel: none(''),
};

export const supportSlice = createSlice({
  name: 'support',
  initialState,
  reducers: {
    setViewModel: (state, action: PayloadAction<SupportScreen.ViewModel>) => {
      state.viewModel = action.payload;
    },
  },
});

export const { setViewModel } = supportSlice.actions;

export default supportSlice.reducer;
